import $ from 'jquery';
import _ from 'lodash';
import { Model }            from 'backbone';
import BasePropertyView from 'BasePropertyView.js';
import constants        from 'Constants.js';
import contentTemplate  from 'dashboard/settings/user-group-details-view.ejs';
import RestService from 'RestService';
import NotificationService from 'NotificationService';
import eventBus from 'EventBus.js';
import undoService from 'UndoService.js'
import SelectItemModalView from 'common-views/SelectItemModalView.js';
import SimpleConfirmModalView from "common-views/SimpleConfirmModalView.js";
import textConstants from 'TextConstants';
import dashboardService from 'DashboardService';
import util from 'util/Util';
import listService from 'ListService.js';
import Spinner from 'spin/spin';

class UserGroupDetailsView extends BasePropertyView {

    initialize(opts) {

        this.options = opts || {};
        this.template = contentTemplate;
        
        this.Spinner = new Spinner();

        this.events = {
            'keyup input': 'updateButtonActions',
            'keyup textarea': 'updateButtonActions',
            'change input[type=text]': 'updateTextInputs',
            'change input[type=checkbox]': 'updateCheckboxesInputs',
            'change textarea': 'updateTextInputs',
            'blur textarea, input[type=text]'   : 'lostFocus',
            'focus textarea, input[type=text]'   : 'getFocus',
            'change select[name=MembersXML]': 'selectMember',
            'click input[name=applyChanges]': 'applyChanges',
            'click input[name=addMemberGroup]': 'showUserName',
            'click input[name=removeMemberGroup]': 'removeMembers',
            'click input[name=cancel]': 'cancelChanges',
            'click input[name=deleteGroup]': 'deleteGroup', 
            'click #goToSettings': 'goToSettings',
            'click #goToAccountSettings': 'goToAccountSettings',
            'click #goToUserGroups': 'goToUserGroups'
        };

        this.loadGroupData();
        this.listenTo(this.model, 'change', this.render);

        return this;
    }

    loadGroupData(){
        const MembersXML = this.model.get('updatedGroupDetails').MembersXML;

        const users = _.get(MembersXML, 'Members.User');
        let MembersArray = [];

        if(users){
            MembersArray = Array.isArray(users) ? users : [users];
        }

        this.model.set({
            MembersArray: MembersArray,
            groupDetails:$.extend(true,{},  this.model.get('updatedGroupDetails')),
            removedUsers: [],
            addedUsers: []
        }, { silent: true });
    }

    selectMember(ev){
        $('#removeMemberGroup').attr('disabled', false);
    }

    showUserName(ev){ 
        this.Spinner.spin($(constants.CONTENT_ID).get(0));
        setTimeout(() => {
            RestService.browseAllUsers().then((userData)=> {
                let users = [];
                if (userData.AllUsers.User) {
                    users = userData.AllUsers.User instanceof Array
                        ? userData.AllUsers.User
                        : [userData.AllUsers.User];
                }

                let items = [];
                users.forEach(user => {                            
                    if (user['@type'] === 'user'){
                        items.push({ 
                            id: user['@id'],
                            label: user['@caption'],
                            listType: 'user',
                            items: user
                        });
                    }
                });

                const selectView = new SelectItemModalView({model: new Model({items:items, subtitle:'Select User'}), spinner: this.Spinner});

                selectView.render().then(selectedItemInModal => {
                    if(selectedItemInModal) {
                        let userChosen = {
                            '@id': selectedItemInModal.id,
                            '@caption': selectedItemInModal.label,
                            '@type': "user"
                        };

                        let MembersArray = this.model.get('MembersArray');
                        let found = false;
                        _.forEach(MembersArray, function (member) {
                            if ( member['@id'] === userChosen['@id'] ) {
                                found = true;
                            }
                        });

                        if (!found){
                            MembersArray. push(userChosen);
                            this.model.set('MembersArray', MembersArray);
                            let added = this.model.get('addedUsers');
                            added.push(userChosen['@id']);
                            this.model.set('addedUsers', added);
                            this.render();
                            this.updateButtonActions();
                        }
                    }
                });
            }).catch((error)=> {
                console.log('Error', error);
                if (error.CODE === '75') {
                    NotificationService.error('An error has ocurred. The maximum number of users with offline app filling enabled has been reached.')
                }
            });
        }, 10);
    }

    removeMembers(ev) {
        let MemberArray = this.model.get('MembersArray');
        let selectedKey = $('#MembersXML').val();
        let index = -1;
        for (let i = 0; i < MemberArray.length; ++i) {
            if (MemberArray[i]['@id'] === selectedKey) {
                index = i;
            }
        }
        if (index > -1) {
            let removed = this.model.get('removedUsers');
            removed.push(MemberArray[index]['@id']);
            this.model.set('removedUsers', removed);
            MemberArray.splice(index, 1);
        }
        this.render();
        this.updateButtonActions();
    }

    cancelChanges() {
        this.model.set('updatedGroupDetails', $.extend(true,{}, this.model.get('groupDetails')), {silent: true});
        let MembersXML =this.model.get('updatedGroupDetails').MembersXML;
        let MembersArray = [];
        if (MembersXML) {
            MembersArray = MembersXML.Members.User instanceof Array ? MembersXML.Members.User : [MembersXML.Members.User]
        }
        this.model.set('hasChanges',false,{silent:true});
        this.model.set('MembersArray', MembersArray, {silent: true});
        this.model.set('removedUsers', []);
        this.model.set('addedUsers', []);
        this.render();
    }


    updateButtonActions() {
        $("#noChangesSection").addClass('hide');
        $("#changesSection").removeClass('hide');
    }

    updateTextInputs(ev) {
        let prop = ev.target.name;
        let value = ev.target.value;
        let userDetails = this.model.get('updatedGroupDetails');
        userDetails[prop] = value;
        this.model.set('updatedGroupDetails', userDetails, {silent: true});
        this.model.set('hasChanges',true,{silent:true});
    }

    updateCheckboxesInputs(ev) {
        let prop = ev.target.name;
        let propVal  = ev.currentTarget.checked;
        let userDetails = this.model.get('updatedGroupDetails');
        userDetails[prop] = propVal? 'true': 'false';
        this.model.set('updatedGroupDetails', userDetails, {silent: true});
        this.model.set('hasChanges',true,{silent:true});
        this.updateButtonActions();
    }

    updateTreeview(){
        eventBus.trigger(constants.UPDATE_USER_GROUP_TREEVIEW,this.model.get('groupId'));
    }

    applyChanges(){
        let self = this;
        let updatedModel = this.model.get('updatedGroupDetails');
        let groupId = this.model.get('groupId');

        const removedUsers = this.model.get('removedUsers');
        const addedUsers = this.model.get('addedUsers');

        const updatedGroup = {
            groupId: groupId,
            name: updatedModel.Name,
            description: updatedModel.Description,
            isActive: updatedModel.IsActive
        };

        const originalModel = this.model.get('groupDetails');

        const originalGroup = {
            groupId: groupId,
            name: originalModel.Name,
            description: originalModel.Description,
            isActive: originalModel.IsActive
        };

        undoService.add({
            undo: () => {
                // by inverting the remove and add parameter
                // we add the removed and remove the added (undo)
                this.persistData(originalGroup, removedUsers, addedUsers, groupId);
            },
            redo: () => {
                this.persistData(updatedGroup, addedUsers, removedUsers, groupId);
            }
        }, textConstants.UNDO_UPDATE_USER_GROUP);

        this.persistData(updatedGroup, addedUsers, removedUsers, groupId);
        util.setUndoRedoAccess();
    }

    persistData(data, addedUsers, removedUsers, groupId){
        this.updateGroup(data).then(() => {
            return this.updateUsersInGroup(addedUsers, removedUsers, groupId);
        }).catch((error)=> {
            this.handleUpdateError(error);
        });
    }

    handleUpdateError(error){
        console.log('Error', error);
        if (error.CODE === '75') {
            NotificationService.error('An error has ocurred. The maximum number of users with offline app filling enabled has been reached.')
        }
    }

    updateGroup(updateGroup){
        return RestService.updateUserGroup(updateGroup);
    }

    updateUsersInGroup(added=[], removed=[], groupId){

        this.addUsersFromGroup(added,groupId).then(() => {
            this.removeUsersFromGroup(removed, groupId).then(()=>{
                if (listService.activeDashboardTab === 'settings'){
                    this.refreshUserData(groupId);
                 }
            });
        }).catch((error)=> {
            this.handleUpdateError(error);
        });    
    }

    removeUsersFromGroup (removed, groupId) {
        this.model.set('hasChanges',true,{silent:true});
        const updatePromises = [];

      _.forEach(removed, (id) => {
            updatePromises.push(()=>{
              return RestService.removeUserFromUserGroup(id, groupId)
            });
      });

      return updatePromises.reduce((p, fn) => {
        return p.then(fn);
      }, Promise.resolve());
    }

    addUsersFromGroup(added, groupId) {
        this.model.set('hasChanges',true,{silent:true});
       
        const updatePromises = [];

        _.forEach(added, (id) => {
            updatePromises.push(()=>{
              return RestService.addUserToUserGroup(id, groupId)
            });
        });
        return updatePromises.reduce((p, fn) => {
          return p.then(fn);
        }, Promise.resolve());
    }

    refreshUserData(groupId){
        RestService.getGroupDetails(groupId).then((groupDetails)=> {
            this.model.set('dashboardTitle', 'User-Group - '+groupDetails.Name, {silent:true});
            this.model.set('groupId', groupId, {silent:true});
            this.model.set('groupDetails', groupDetails, {silent:true});
            this.model.set('updatedGroupDetails', Object.assign({}, groupDetails), {silent:true});

            this.loadGroupData();

            this.render();
            this.updateTreeview();
        }).catch((error)=> {
            console.log('Error', error);
            if (error.CODE === '75') {
                NotificationService.error('An error has ocurred. The maximum number of users with offline app filling enabled has been reached.')
            }
        });
    }

    deleteGroup(ev) {       
        try {
            dashboardService.deleteUserGroup();
        }
        catch(e) {
            console.log("Error", e);
        }
    }

    render() {
        this.$el.empty();
        if (this.template) {
            this.$el.html(this.template(this.model.toJSON()));
        }

        this.delegateEvents();
        this.$el.css('cursor', 'default');

        return this;
    }

    refresh(){
        if(this.model.get('hasChanges')){
            
            let simpleModal=new SimpleConfirmModalView({
                model:new Model({subtitle:`User Group Details - ${this.model.get("groupDetails").Name}`,
                    confirmationText:`Are you sure you want to refresh this page?\r All changes made on the current page will be lost.`,
                    height:200,
                    width:400})
            });
            simpleModal.render().then((result)=>{
                if (result === 'Ok') {
                    eventBus.trigger(constants.EV_REFRESH_USER_GROUP_DETAILS,this.model.get('groupId'));
                }
            }).catch((err)=> {
                console.log('Error Showing Refresh Confirmation Message', err);
                NotificationService.error('Error Showing Refresh Confirmation Message' + err.MESSAGE);
            });
        }
        else{
            eventBus.trigger(constants.EV_REFRESH_USER_GROUP_DETAILS,this.model.get('groupId'));
        }  
    }

    goToSettings(e) {
        e.preventDefault();
        e.stopPropagation();

        eventBus.trigger('loadSettingsView');
    }

    goToAccountSettings(e) {
        e.preventDefault();
        e.stopPropagation();

        $('div.document-heading > a[data-target="#well_1"]').click();
    }
    
    goToUserGroups(e) {
        e.preventDefault();
        e.stopPropagation();

        $('div#well_2 a[data-itemid="userGroupsGroup"]').click();
    }
}

export default UserGroupDetailsView;

